import React from 'react';
import {
  FiBriefcase,
  FiUsers,
  FiGlobe,
  FiClock,
  FiCalendar,
  FiMonitor,
  FiBell,
  FiClipboard,
  FiGift,
  FiShield,
  FiSliders,
} from 'react-icons/fi';

import { settingsNavKeys } from '../SettingsRedesign.constants';
import { SettingsNavItem } from './SettingsNavItem.component';

import styles from './SettingsNavList.module.scss';

const NAV_ICON_MAP = {
  [settingsNavKeys.company]: FiBriefcase,
  [settingsNavKeys.teamSettings]: FiUsers,
  [settingsNavKeys.appsAndUrls]: FiGlobe,
  [settingsNavKeys.workingHours]: FiClock,
  [settingsNavKeys.workingDays]: FiCalendar,
  [settingsNavKeys.screenshotsMonitoring]: FiMonitor,
  [settingsNavKeys.alertsNotifications]: FiBell,
  [settingsNavKeys.leaveAttendance]: FiClipboard,
  [settingsNavKeys.holidays]: FiGift,
  [settingsNavKeys.privacySecurity]: FiShield,
  [settingsNavKeys.advanced]: FiSliders,
};

export const SettingsNavList = ({ items = [], activeKey, onSelect }) => (
  <div className={styles.navList}>
    {items.map((item) => (
      <SettingsNavItem
        key={item.key}
        icon={NAV_ICON_MAP[item.key]}
        title={item.title}
        subtitle={item.subtitle}
        active={item.key === activeKey}
        onClick={() => onSelect?.(item.key)}
      />
    ))}
  </div>
);

SettingsNavList.displayName = 'SettingsNavList';
